import { render, staticRenderFns } from "./newsdworker.vue?vue&type=template&id=d2114ba2&"
import script from "./newsdworker.vue?vue&type=script&lang=js&"
export * from "./newsdworker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports